import React from 'react';
import { Grid, Typography } from '@mui/material';
import CardsItemEventos from './CardsItemEventos';
import './CardsEventos.css';

function CardsEvento() {
    const media = (fileName) => encodeURI(`/media/eventos/${fileName}`);

    return (
        <div className="cards_evento">
        <section className=" counter-wrapper_evento section-sm">
 
        <Typography
    variant="h1"
    align="center"
    gutterBottom
    style={{
      fontFamily: "'Lato', serif",
      color: "black",
      borderBottom: "4px solid #d4af37",
      paddingBottom: "10px",
      textTransform: "uppercase",
      animation: "glow 2s infinite alternate",
      marginTop: "7%"  // Aqui é onde você define o espaço superior
    }}
  > Eventos
    </Typography>
            <h2>O ensino da fé cristã na Península Ibérica</h2>
            <div className='cards__container_evento'>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>
                        <CardsItemEventos
                            src={media('VIEvento.jpg')}
                            name="VI Evento Internacional"
                            text="Instrução e a persuasão dos exempla, dias 4, 5 e 6 de Junho"
                            path="/VI_Evento_Internacional"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CardsItemEventos
                            src={media('VEvento.jpg')}
                            name="V Evento Internacional"
                            text="Práticas de devoção no mundo Ibérico medieval, 29 e 30 de Agosto de 2023"
                            path="/V_Evento_Internacional"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CardsItemEventos
                            src={media('IV Evento Internacional.jpeg')}
                            name="IV Evento Internacional"
                            text="Ética e formação moral do exemplum, 9, 10 e 11 de Agosto de 2022"
                            path="/IV_Evento_Internacional"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <CardsItemEventos
                            src={media('Curso de Introducao à Paleografia - Hugo Bizzarri.png')}
                            name="Curso de Introdução à Paleografia Ibérica Medieval e Moderna"
                            text="Curso de Introdução à Paleografia Ibérica"
                            path="/Curso_de_Introdução_Paleografia"
                        />
                    </Grid>


                    <Grid item xs={12} sm={6} md={4}>
                        <CardsItemEventos
                            src={media('III Evento.jpg')}
                            name='III Evento Internacional
                Aconselhar e prescrever em terras cristãs'
                            text='III Evento Internacional- Aconselhar e prescrever em terras cristãs
              20,21,22 e 23 de setembro de 2021'
                            label='Visitar'
                            path='/III_Evento_Internacional'
                        />
                    </Grid>
 
                    <Grid item xs={12} sm={6} md={4}>
                        <CardsItemEventos
                            src={media('II Evento.jpg')}
                            name='II Evento Internacional
                A FORMAÇÃO DE REINOS VIRTUOSOS NA IDADE MÉDIA'
                            text='Evento realizado nos dias 07, 08 e 09 de Outubro de 2020, evento realizado virtualmente com a presença de 20 campi e 59 participantes.'
                            label='Visitar'
                            path='/II_Evento_Internacional'
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <CardsItemEventos
                            src={media('A devoção popular na Idade Média.jpg')}
                            name='A devoção popular na Idade Média'
                            text='Palestra do Prof. Dr. Jean-Claude Schmitt na UNESP/Câmpus de Franca.'
                            label='Visitar'
                            path='/A_devocao_popular_na_Idade_Media'
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <CardsItemEventos
                            src={media('I Seminário.jpg')}
                            name='I Seminário do Grupo “O Ensino da Fé Cristã na Península Ibérica (sécs. XIV e XV)"'
                            text='Realizado nos dias 23 e 24 de Setembro de 2019, no auditório Fausto Castilho no IFCH / Unicamp.'
                            label='Visitar'
                            path='/I_Seminario_do_Grupo'
                        />
                    </Grid>
                </Grid>





            </div>
 
        </section> 
        </div>
    );
}

export default CardsEvento;
